import { Anchor, Box, Button, Card, Center, Container, Text, TextInput } from '@mantine/core';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import ErrorMessage from '../components/ErrorMessage';
import Metadata from '../components/Metadata';
import { Page } from '../constants/pageTitles';
import useFetch from '../helpers/useFetch';
import mainLogo from '../logo.png';

const ResetPasswordPage = () => {
  const navigate = useNavigate();
  const fetch = useFetch();

  const [email, setEmail] = useState('');
  const [error, setError] = useState('');

  const submitForm = (e) => {
    setError(undefined);
    e.preventDefault();
    fetch(`/api/admin/users/sendResetPasswordToken`, {
      method: 'POST',
      body: JSON.stringify({ email }),
    })
      .then(() => {
        navigate('/resetPassword/emailSent');
      })
      .catch(setError);
  };

  return (
    <div>
      <Metadata title={`${Page['resetPassword']}`} />
      <Center pt={60} h="100%">
        <Container size="xs" w="100%">
          <Card withBorder p="lg">
            <Box ta="center" py="md">
              <img src={mainLogo} alt="Releva" style={{ maxWidth: '100%', height: 'auto' }} />
            </Box>
            <br />
            <br />

            <Box component="form" ta="left" onSubmit={(e) => submitForm(e)}>
              <TextInput
                size="lg"
                name="email"
                type="email"
                label="Email"
                placeholder="Your Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                mb="md"
              />

              <ErrorMessage message={error?.message} />
              <br />
              <Box>
                <Button fullWidth size="lg" type="submit" disabled={!email}>
                  Yes, Reset my password
                </Button>
              </Box>
            </Box>
          </Card>
          <br />
          <br />
          <Text ta="center">
            Remembered your pasword? <Anchor href="#/login">Log in here.</Anchor>
          </Text>
        </Container>
      </Center>
    </div>
  );
};

export default ResetPasswordPage;
